module.exports = "<nav class=\"navbar navbar-light bg-color header-shadow text-xs-center\">\r\n  <a href=\"/\">\r\n    <img ng-src={{header.logo}} alt=\"Wild Birds Unlimited\" height=\"45\" />\r\n  </a>\r\n</nav>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/auth-header/auth-header.html
// module id = 268
// module chunks = 0